import { Component } from 'react';
import { setSentryError } from 'utils/sentry';
import ErrorBoundaryInfo from './ErrorBoundaryInfo';

interface Props {
  children: JSX.Element | JSX.Element[];
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    setSentryError(error, errorInfo);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  refreshApp = () => {
    window.location.reload();
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <ErrorBoundaryInfo onClick={this.refreshApp} />;
    }

    return children;
  }
}

export default ErrorBoundary;
